export const MAX_COMMENT_LENGTH = 2000;
